import RolConfig from "./RolConfig";
import AuthService from "../auth/AuthService"
export default class UserService {
  /******* ROLES **********/
  static getRoles(app) {  
    return new Promise(async (resolve, reject) => {
      try{
        
        let token = await AuthService.getToken()
        let endpoint = RolConfig.endpointRoles;
        let response = await RolConfig.APIConnector.get(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
        });
        console.log("getRoles", response, app)
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  static getRolesRedimidores(app) {  
    return new Promise(async (resolve, reject) => {
      try{
        
        let token = await AuthService.getToken()
        let endpoint = RolConfig.endpointRolesRedimidores;
        let response = await RolConfig.APIConnector.get(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
        });
        console.log("getRolesRedimidores", response, app)
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  static saveRol(app, rol) {  
    return new Promise(async (resolve, reject) => {
      try{
        console.log("SERVICE SAVE ROL", rol)
        let token = await AuthService.getToken()
        let endpoint = RolConfig.endpointSaveRol;
        console.log("ENDPOINT SAVE ROL", endpoint)
        let response = await RolConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body: JSON.stringify(rol)
        });
        console.log("saveRol", response, app)
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }
  
  
  static deleteRol(app, rol) {  
    return new Promise(async (resolve, reject) => {
      try{
        console.log("SERVICE DELETE ROL", rol)
        let token = await AuthService.getToken()
        let endpoint = RolConfig.endpointDeleteRol;
        console.log("ENDPOINT DELETE ROL", endpoint)
        let response = await RolConfig.APIConnector.delete(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body: JSON.stringify(rol)
        });
        console.log("deleteRol", response, app)
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }
  /******** FIN ROLES *********/

}


// WEBPACK FOOTER //
// ./src/provider/rol/RolService.js